import React, { useState, useEffect } from "react";
import {
    Alert,
    Button,
    ButtonGroup,
    Container,
    Card,
    Col,
    Form,
    Row,
    Modal,
    Spinner,
    OverlayTrigger,
    Tooltip,
    Dropdown,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import CustomNavbar from "../../components/CustomNavbar";
import CustomTable from "../../components/CustomTable";
import CustomPagint from "../../components/CustomPagint";


import {
    getCompanyResponsible,
    saveCompanyResponsible,
    editCompanyResponsible,
    deleteCompanyResponsible

} from "../../redux/CompanyResponsibles/actions"

import {
    getUsers
} from "../../redux/auth/actions";

import { getCompanias } from '../../redux/compania/actions';


import messages from "../../redux/messages";
import SidebarConfig from "../../components/SidebarConfig";
import { Formik } from "formik";
import * as Yup from "yup";
import { Typeahead } from "react-bootstrap-typeahead";
import Multiselect from "../../components/MultiselectFormik";
import "../../css/matrizSucesion.css";


const CompanyResponsibles = (props) => {
    const schema = Yup.object().shape({
        list_empresas: Yup.array().test({
            message: "**Campo requerido",
            test: (val) => val.length !== 0,
        }),
        user_id: Yup.string().required("**Campo requerido"),
    });

    const [offset, setOffset] = useState(0);
    const [limit, setLimit] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [edit, setEdit] = useState(false);
    const [index, setIndex] = useState(0);
    const [editItem, setEditItem] = useState({});
    const [showModal, setShowModal] = useState(false);
    const [filter, setFilter] = useState("");
    //const [loadingType, setLoadingType] = useState('initial');
    const [validated, setValidated] = useState(false);
    const [show, setShow] = useState(false);
    const [companiesGroup, setCompaniesGroup] = useState([]);
    const [tipoBusqueda, setTipoBusqueda] = useState({
        id: "username",
        desc: "Usuario",
    });

    const filters = [
        { id: "username", desc: "Usuario" },
        { id: "first_name__icontains", desc: "Nombre" },
        { id: "groups__name__icontains", desc: "Grupo" },
        { id: "roles_usuario_empresa__empresa__nombre__icontains", desc: "Empresa" },

    ];

    const dispatch = useDispatch();

    const {
        companyResponsibles,
        companyResponsiblesLength,
        loading,
        saveLoading,
        companyResponsibleError,
        formError,
    } = useSelector((store) => store.companyResponsible);

    const {
        users,
        loadingAuth,

    } = useSelector((store) => store.auth);

    const {
        compania,
        companiaLoader,
    } = useSelector(store => store.compania);

    const pages = Math.ceil(companyResponsiblesLength / limit);

    const usuariosOptions = users
        ? users
            .map((item) => ({
                id: item.id,
                label: `${item.first_name}`,
                item: item,
            }))
        : [];

    let empresasOptions = []


    compania.map((item) => {
        empresasOptions = [...empresasOptions, { value: item.id, label: `${item.codigo}/${item.nombre}` }];
    });

    const columns = [

        {
            Header: "Usuario",
            accessor: "usuario",
        },
        {
            Header: "Roles",
            accessor: "grupos",
            Filter: "",
            Cell(value) {
                return (

                    <div style={{ display: 'flex', alignItems: 'center' }}>

                        {!value.row.original.grupos || value.row.original.grupos.length === 0 ?
                            (
                                <div className="main-container">
                                    <Alert variant="info">
                                        Sin grupos que mostrar.
                                    </Alert>
                                </div>
                            )
                            : (
                                <div className="main-container">
                                    {value.row.original.grupos.map(grupo => (
                                        <div style={{ display: 'flex', alignItems: 'center', flexDirection: "row" }}>
                                            <div className="container-option">
                                                <span>{grupo.name}</span>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}

                    </div>

                )

            }
        },
        {
            Header: "Empresas",
            accessor: "empresas",
            Filter: "",
            Cell(value) {
                return (

                    <div style={{ display: 'flex', alignItems: 'center' }}>

                        {!value.row.original.empresas || value.row.original.empresas.length === 0 ?
                            (
                                <div className="main-container">
                                    <Alert variant="info">
                                        Sin empresas que mostrar.
                                    </Alert>
                                </div>
                            )
                            : (
                                <div className="main-container">
                                    {value.row.original.empresas.map(empresa => (
                                        <div style={{ display: 'flex', alignItems: 'center', flexDirection: "row" }}>
                                            <div className="container-option">
                                                <span>{empresa.nombre}</span>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}

                    </div>

                )

            }
        },
        {
            id: "customButtons",
            Filter: "",
            Cell: (value) => (
                <div className="btn-group" role="group">
                    <Button
                        size="sm"
                        variant="link"
                        type="button"
                        onClick={() => onEdit(value.row.original, value.row.index)}
                    >
                        <i className="material-icons">edit</i>
                    </Button>

                </div>
            ),
        },
    ];

    // Métodos
    const _getCompanyResponsible = (offs = offset, lim = limit, filt = filter) => {
        let params = filt ? {
            offset: offs,
            limit: lim,
            filter_kwargs: {
                [tipoBusqueda.id]: filt,
            }
        } : {
            offset: offs,
            limit: lim
        }
        dispatch(
            getCompanyResponsible(
                params
            )
        );
    }


    const _getCompanias = () => {
        dispatch(getCompanias(parseInt(props.match.params.type)));
    }

    const _getUsers = () => {
        dispatch(getUsers());
    }

    useEffect(() => {
        _getCompanyResponsible()
        _getCompanias()
        _getUsers()
    }, []);

    const onAdd = () => {
        setShowModal(true);
        setEdit(false);
        //setLoadingType('modal');
        setValidated(false);
        setCompaniesGroup([]);
    };

    const onEdit = (item, index) => {
        setIndex(index);
        let companies = [];
        item?.empresas && item.empresas.map((empresa) => {
            companies.push({ value: empresa.id });
        });
        setCompaniesGroup(companies)
        setEdit(true);
        setEditItem(item);
        setShowModal(true);
        //setLoadingType('modal');
        setValidated(false);
        console.log(item, index)
    };

    const onSearch = (e) => {
        e.preventDefault();

        setFilter(e.target.filter.value);
        const oOffset = 0;
        setOffset(oOffset);
        setCurrentPage(1);
        _getCompanyResponsible(oOffset, limit, e.target.filter.value);
    };

    const onSubmitForm = (req) => {

        console.log("req", req)
        let companies = []

        req.list_empresas.map((item) => {
            companies.push(parseInt(item.value))
        })
        let data = {
            list_empresas : companies
        }
        console.log(req.user_id, data, index)
        dispatch(editCompanyResponsible(
            data,
            req.user_id,
            index,
            setShowModal
        ))

    };

    const seeAll = () => {
        const oSearch = "";
        setFilter(oSearch);
        const oOffset = 0;
        setOffset(oOffset);
        setCurrentPage(1);
        _getCompanyResponsible(oOffset, limit, oSearch);
    };

  
    const onShowSidebar = () => setShow(show ? false : true);

    return (
        <>
            <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
            <SidebarConfig show={show} onShowSidebar={onShowSidebar} />
            <div className="custom-wrapper">
                <Container fluid>
                    <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
                        <h6 className="font-weight-bold text-uppercase">
                            Usuarios Empresa
                            {parseInt(props.match.params.type) === 1 ? "Formal" : " Funcional"}
                        </h6>
                        <Form onSubmit={onSearch}>
                            <Row className="justify-content-end align-items-center flex-nowrap">
                                <Col>
                                    <h6>
                                        <b>Busqueda por: {tipoBusqueda.desc}</b>
                                    </h6>
                                </Col>
                                <Col xs="auto">
                                    <Form.Control
                                        name="filter"
                                        id="filter"
                                        placeholder="Buscar"
                                        className="rounded-pill form-control-sm"
                                        type="search"
                                    ></Form.Control>
                                </Col>
                                <Col xs="auto">
                                    <ButtonGroup>
                                        <Button
                                            onClick={() => seeAll()}
                                            variant="light"
                                            size="sm"
                                            className="rounded-circle mr-1"
                                        >
                                            <i className="material-icons">list</i>
                                        </Button>
                                        <OverlayTrigger
                                            placement="auto"
                                            overlay={
                                                <Tooltip {...props}>Seleccionar Filtrado</Tooltip>
                                            }
                                        >
                                            <Dropdown className="ml-3 mr-3">
                                                <Dropdown.Toggle
                                                    variant="light"
                                                    className="btn-sm font rounded-pill"
                                                >
                                                    <i className="material-icons">filter_list</i>
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu>
                                                    {filters.map((item) => (
                                                        <Dropdown.Item
                                                            onClick={() => setTipoBusqueda(item)}
                                                            key={item.id}
                                                        >
                                                            {item.desc}
                                                        </Dropdown.Item>
                                                    ))}
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </OverlayTrigger>
                                    </ButtonGroup>
                                </Col>
                            </Row>
                        </Form>
                    </div>
                    {loading ? (
                        <div className="d-flex justify-content-center">
                            <Spinner
                                animation="border"
                                role="status"
                                className="d-flex justify-content-center"
                            />
                        </div>
                    ) : (
                        companyResponsiblesLength > 0 && (
                            <>
                                <Card className="border-0">
                                    <Card.Body className="px-1 px-sm-2">
                                        <CustomTable columns={columns} data={companyResponsibles} />
                                    </Card.Body>
                                </Card>
                                <CustomPagint
                                    limit={limit}
                                    setLimit={setLimit}
                                    offset={offset}
                                    setOffset={setOffset}
                                    currentPage={currentPage}
                                    setCurrentPage={setCurrentPage}
                                    dataLenght={companyResponsiblesLength}
                                    pages={pages}
                                    pagFunc={_getCompanyResponsible}
                                />
                            </>
                        )
                    )}
                    {!loading &&
                        companyResponsiblesLength === 0 &&
                        companyResponsibleError === "" && (
                            <Alert variant="info" className="my-4">
                                Aún no hay usuarios asignados a empresas, comienza agregando algunos
                            </Alert>
                        )}
                    {!loading && !!companyResponsibleError && (
                        <Alert variant="danger" className="my-4">
                            {companyResponsibleError}
                        </Alert>
                    )}
                </Container>
            </div>
            <Modal show={showModal} onHide={() => setShowModal(false)}>
                <Formik
                    validationSchema={schema}
                    onSubmit={onSubmitForm}
                    initialValues={{
                        list_empresas: edit ? companiesGroup : [],
                        user_id: edit ? editItem.user_id : ""
                    }}
                >
                    {({
                        handleSubmit,
                        handleChange,
                        handleBlur,
                        setFieldValue,
                        values,
                        touched,
                        isValid,
                        errors,
                    }) => (
                        <Form onSubmit={handleSubmit} noValidate validated={validated}>
                            <Modal.Header closeButton>
                                <Modal.Title>
                                    {edit ? "Editar Usuario Empresa" : "Crear Usuario Empresa"}
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                {!!formError && (
                                    <Alert variant="danger" className="my-1">
                                        {formError}
                                    </Alert>
                                )}
                                <Form.Group as={Row} className="mb-3">
                                    <Form.Label column sm="12" md="4">
                                        Usuario:
                                    </Form.Label>

                                    <Col sm="12" md="8">
                                        <Typeahead
                                            id="user_id"
                                            name="user_id"
                                            isInvalid={touched.user_id && errors.user_id}
                                            isValid={touched.user_id && !errors.user_id}
                                            onBlur={handleBlur("user_id")}
                                            placeholder="Seleccione un usuario"
                                            options={usuariosOptions}
                                            value={values.user_id}
                                            onChange={(selected) => {
                                                setFieldValue(
                                                    "user_id",
                                                    selected.length > 0 ? selected[0].id : "",

                                                );

                                            }}
                                            defaultInputValue={edit ? `${editItem.usuario}`
                                                : ""}
                                            disabled={edit}

                                        >
                                        </Typeahead>
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3">
                                    <Form.Label column sm="12" md="4">
                                        Empresa
                                    </Form.Label>
                                    <Col sm="12" md="8">
                                        <Row className="align-items-center">
                                            <Col sm={companiaLoader ? "10" : "12"}>
                                                <Multiselect
                                                    id="list_empresas"
                                                    name="list_empresas"
                                                    options={empresasOptions}
                                                    value={values.list_empresas}
                                                    onChange={(selected) => {
                                                        setFieldValue(
                                                            "list_empresas",
                                                            selected.length > 0 ? selected : []
                                                        );
                                                    }}
                                                    isValid={touched.list_empresas && !errors.list_empresas}
                                                    isInvalid={touched.list_empresas && errors.list_empresas}
                                                    onBlur={() => handleBlur("list_empresas")}
                                                />
                                                {touched.list_empresas && errors.list_empresas && (
                                                    // <div>
                                                    <small className="mx-2 text-danger">
                                                        {errors.list_empresas}
                                                    </small>
                                                    // </div>
                                                )}

                                            </Col>
                                            {companiaLoader && (
                                                <Col sm="2">
                                                    <Spinner animation="border" size="sm" />
                                                </Col>
                                            )}
                                        </Row>
                                    </Col>
                                </Form.Group>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button
                                    className="rounded-pill"
                                    variant="secondary"
                                    onClick={() => setShowModal(false)}
                                >
                                    Cerrar
                                </Button>
                                <Button
                                    className="rounded-pill"
                                    disabled={saveLoading}
                                    variant="primary"
                                    type="submit"
                                >
                                    {saveLoading && (
                                        <Spinner
                                            className="mr-2"
                                            as="span"
                                            animation="border"
                                            size="sm"
                                            role="status"
                                            aria-hidden="true"
                                        />
                                    )}
                                    Guardar
                                </Button>
                            </Modal.Footer>
                        </Form>
                    )}
                </Formik>
            </Modal>
        </>
    );
};

export default CompanyResponsibles;
